import { motion } from 'framer-motion'
import { staggerContainer, staggerItem } from '../lib/motion.ts'
import SectionTitle from './SectionTitle.tsx'

const Testimonials = () => {
  return (
    <section className="section-padding overflow-hidden">
      <div className="container">
        <SectionTitle
          subtitle="Clients"
          title="Trusted by Industry Leaders."
          description="Proud to partner with organizations that set the standard in healthcare and emergency services."
        />

        {/* Trust Indicators */}
          <motion.div 
            variants={staggerContainer}
            className="grid grid-cols-3 md:grid-cols-3 gap-10 items-center opacity-60 pt-20"
          >
            {[
              'sunstar-black.png',
              'pcemsomd-black.png',
              'flcems-black.png',
              'pmc-group-black.png',
              'pcare-black.png',
              'school-of-ems-black.png',
            ].map((logo) => (
              <motion.div
                key={logo}
                variants={staggerItem}
                className="text-center"
              >
                <div className="h-18 bg-white rounded-lg flex items-center justify-center">
                  <img
                    src={`/assets/logos/${logo}`}
                    alt={logo.replace(/\.[a-z]+$/, '')}
                    className="h-14 object-contain mx-auto"
                  />
                </div>
              </motion.div>
            ))}
          </motion.div>
      </div>
    </section>
  )
}

export default Testimonials
